'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _Segment = require('./Segment.jsx');

var _Segment2 = _interopRequireDefault(_Segment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Segments(props) {
  var segments = props.segments;


  return _react2.default.createElement(
    'table',
    { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'Segments' },
    _react2.default.createElement(
      'tbody',
      null,
      segments.map(function (segment, i) {
        return _react2.default.createElement(
          'tr',
          { key: i },
          _react2.default.createElement(
            'td',
            { style: { padding: '0' } },
            _react2.default.createElement(_Segment2.default, { segment: segment })
          )
        );
      })
    )
  );
}

var mstp = function mstp(state) {
  return {
    components: state.templateApplication.templates.currentTemplate.components
  };
};

exports.default = (0, _reactRedux.connect)(mstp)(Segments);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/Email/Segments.jsx
// module id = 1483
// module chunks = 0